import { render } from "./AlertModal.vue?vue&type=template&id=9cbfdd9c&scoped=true"
import script from "./AlertModal.vue?vue&type=script&lang=js"
export * from "./AlertModal.vue?vue&type=script&lang=js"

import "./AlertModal.vue?vue&type=style&index=0&id=9cbfdd9c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9cbfdd9c"]])

export default __exports__